import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ScrollProgress from './components/base/ScrollProgress';
import FloatingActionButton from './components/base/FloatingActionButton';
import ChatbotWidget from './components/feature/ChatbotWidget';
import { useState } from 'react';
import { AuthProvider } from './context/AuthContext';

function App() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  const handleWhatsAppClick = () => {
    const phoneNumber = '+919020500700';
    const message = 'Hello! I would like to know more about your study abroad services.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleChatWithAI = () => {
    setIsChatbotOpen(true);
  };

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <div className="min-h-screen bg-white">
          <ScrollProgress />
          <AppRoutes />

          <FloatingActionButton
            onClick={handleWhatsAppClick}
            position="bottom-left"
            className="w-14 h-14 bg-green-500 hover:bg-green-600"
            icon="ri-whatsapp-fill"
            title="Chat on WhatsApp"
            delay={0.5}
          />
          <FloatingActionButton
            onClick={handleChatWithAI}
            position="bottom-right"
            className="px-6 py-4 bg-gradient-to-r from-purple-600 to-pink-600"
            icon="ri-robot-line"
            title="Chat with AI Agent"
            delay={1}
          >
            <span className="hidden sm:inline">Chat With AI Agent</span>
            <span className="sm:hidden">AI Chat</span>
          </FloatingActionButton>
          
          <ChatbotWidget isOpen={isChatbotOpen} onClose={() => setIsChatbotOpen(false)} />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;